/**
 * Schedule page translations
 */
export const scheduleTranslations = {
  en: {
    title: 'Book a Class',
    subtitle: 'Select a teacher and time that works for you',
    selectTeacher: 'Select a Teacher',
    selectDate: 'Select a Date',
    selectTime: 'Select a Time',
    noTeachers: 'No teachers available at the moment',
    noSlots: 'No available slots for this date',
    bookClass: 'Book Class',
    booking: 'Booking...',
    backToDashboard: 'Back to Dashboard',
    confirmBooking: 'Confirm Booking',
    classDetails: 'Class Details',
    teacher: 'Teacher',
    date: 'Date',
    time: 'Time',
    duration: 'Duration',
    minutes: 'minutes',
    bookingSuccess: 'Class booked successfully!',
    bookingError: 'Failed to book class. Please try again.',
    loginRequired: 'Please log in to book a class',
    step: 'Step'
  },
  ko: {
    title: '수업 예약',
    subtitle: '선생님과 시간을 선택하세요',
    selectTeacher: '선생님 선택',
    selectDate: '날짜 선택',
    selectTime: '시간 선택',
    noTeachers: '현재 이용 가능한 선생님이 없습니다',
    noSlots: '해당 날짜에 이용 가능한 시간이 없습니다',
    bookClass: '수업 예약',
    booking: '예약 중...',
    backToDashboard: '대시보드로 돌아가기',
    confirmBooking: '예약 확인',
    classDetails: '수업 정보',
    teacher: '선생님',
    date: '날짜',
    time: '시간',
    duration: '수업 시간',
    minutes: '분',
    bookingSuccess: '수업이 성공적으로 예약되었습니다!',
    bookingError: '수업 예약에 실패했습니다. 다시 시도해주세요.',
    loginRequired: '수업을 예약하려면 로그인하세요',
    step: '단계'
  },
  ja: {
    title: 'レッスン予約',
    subtitle: '講師と時間を選択してください',
    selectTeacher: '講師を選択',
    selectDate: '日付を選択',
    selectTime: '時間を選択',
    noTeachers: '現在利用可能な講師がいません',
    noSlots: 'この日は空きがありません',
    bookClass: 'レッスン予約',
    booking: '予約中...',
    backToDashboard: 'ダッシュボードに戻る',
    confirmBooking: '予約を確認',
    classDetails: 'レッスン詳細',
    teacher: '講師',
    date: '日付',
    time: '時間',
    duration: '時間',
    minutes: '分',
    bookingSuccess: 'レッスンが正常に予約されました！',
    bookingError: 'レッスンの予約に失敗しました。もう一度お試しください。',
    loginRequired: 'レッスンを予約するにはログインしてください',
    step: 'ステップ'
  }
};

/**
 * Get days in month for calendar
 */
export const getDaysInMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const days = [];
  
  // Add empty days for alignment
  for (let i = 0; i < firstDay.getDay(); i++) {
    days.push(null);
  }
  
  // Add days of month
  for (let i = 1; i <= lastDay.getDate(); i++) {
    days.push(new Date(year, month, i));
  }
  
  return days;
};

/**
 * Check if date is selectable (today or future)
 */
export const isDateSelectable = (date) => {
  if (!date) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date >= today;
};

/**
 * Get locale string from language code
 */
const getLocale = (lang) => {
  const locales = { ko: 'ko-KR', ja: 'ja-JP', en: 'en-US' };
  return locales[lang] || locales.en;
};

/**
 * Format date based on language
 */
export const formatDate = (date, language) => {
  return date.toLocaleDateString(getLocale(language), {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
